import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';

function LocalGTMProvider(props) {
  const { children } = props;
  const gtmId = process.env.REACT_APP_GTM_ID;

  if (!gtmId) {
    return children;
  }

  return <GTMProvider state={{ id: gtmId }}>{children}</GTMProvider>;
}

export default LocalGTMProvider;
